<template>
  <div>
    <div class="flex items-baseline justify-between">
      <h2 class="intro-y text-lg font-medium mt-10">{{ $t("views.perfil_marca.text1") }}</h2>
      <button type="button" class="btn btn-primary w-24 h-10" @click="newMarcaSupplementItem">
        <span>{{ $t("views.new") }}</span>
      </button>
    </div>
    <div class="grid grid-cols-12 gap-6 mb-12">
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
        <p class="mr-auto">{{ $t("views.supplements.text2") }}</p>
        <!-- seleccion  certification-->
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="certification">
              <option value="0">{{ $t("views.perfil_marca.text20") }}</option>
              <option v-for="(cert, key) in certificationsBrand" :key="key" :value="cert.id">{{ cert.name }}</option>
            </TomSelect>
          </div>
        </div>
        <div class="cursor w-full sm:w-56 mt-3 sm:mt-0 sm:ml-auto md:ml-0 mr-5">
          <!-- seleccion  estado -->
          <div class="w-full relative text-gray-700 dark:text-gray-300">
            <TomSelect class="w-full cursor" v-model="statusFilter">
              <option value="0">{{ $t("views.supplements.text96") }}</option>
              <option value="1">{{ $t("views.perfil_marca.UNREVIEWED") }}</option>
              <option value="2">{{ $t("views.perfil_marca.REVIEWED") }}</option>
            </TomSelect>
          </div>
        </div>
        <div class="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
          <div class="w-56 relative text-gray-700 dark:text-gray-300">
            <input
              type="text"
              class="form-control w-56 box pr-10 placeholder-theme-13"
              :placeholder="$t('views.supplements.text4')"
              v-model="searchInput"
            />
            <SearchIcon class="w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0" />
          </div>
        </div>
      </div>
      <!-- BEGIN: Data List -->
      <div class="intro-y col-span-12 overflow-auto">
        <table class="table table-report -mt-2">
          <thead>
            <tr>
              <th class="whitespace-nowrap">
                <div class="grid supplements-grid">
                  <div>{{ $t("views.perfil_marca.text2") }}</div>
                  <div>{{ $t("views.perfil_marca.text3") }}</div>
                  <div>{{ $t("views.perfil_marca.text8") }}</div>
                  <div>{{ $t("views.perfil_marca.text10") }}</div>
                  <div>{{ $t("views.perfil_marca.text15") }}</div>
                </div>
              </th>
              <th class="text-center whitespace-nowrap">{{ $t("views.productos.text36") }}</th>
              <th class="text-center whitespace-nowrap">{{ $t("views.supplements.text8") }}</th>
            </tr>
          </thead>
          <tbody class="">
            <template v-for="(item, itemKey) in brands" :key="itemKey">
              <tr class="intro-x">
                <td>
                  <div class="grid supplements-grid cursor-pointer" @click="item.show = !item.show">
                    <!-- nombre a la vista -->
                    <div>{{ item.name }}</div>
                    <!-- url a la vista -->
                    <div v-if="!item.show" class="flex flex-wrap">
                      <div>{{ item.url }}</div>
                    </div>
                    <!-- contacto nombre a la vista -->
                    <div v-if="!item.show" class="flex flex-wrap">
                      <ul class="mt-2 truncate" v-if="item.contacts.length > 0">
                        <li v-for="(contact, key) in item.contacts" :key="key">{{ contact.nameCont }}</li>
                      </ul>
                    </div>
                    <!-- contacto email la vista -->
                    <div v-if="!item.show" class="flex flex-wrap">
                      <ul class="mt-2 truncate" v-if="item.contacts.length > 0">
                        <li v-for="(contact, key) in item.contacts" :key="key">{{ contact.email }}</li>
                      </ul>
                    </div>
                    <!-- certification a la vista -->
                    <div v-if="!item.show" class="flex flex-wrap">
                      <div v-if="item.certification && item.certification.length" class="certifications-container">
                        <span
                          v-for="(cert, index) in item.certification"
                          :key="index"
                          class="py-1 px-2 rounded-md text-xs bg-theme-9 text-white cursor-pointer font-medium mr-3 my-1 bg-color-1"
                        >
                          {{ getNameCertification(cert) }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="w-full intro-x mt-5" v-if="item.show">
                    <!-- nombre -->
                    <h2 v-if="item.name !== ''" class="dark:text-white font-medium mt-3">
                      {{ $t("views.perfil_marca.text2") }}:
                    </h2>
                    <p v-if="item.name !== ''" class="mt-3">{{ item.name }}</p>
                    <!-- url -->
                    <h2 v-if="item.url !== ''" class="dark:text-white font-medium mt-2">
                      {{ $t("views.perfil_marca.text3") }}:
                    </h2>
                    <p v-if="item.url !== ''" class="mt-3">{{ item.url }}</p>
                    <!-- Mostrar contacto -->
                    <h2 v-if="item.contacts.length > 0" class="dark:text-white font-medium mt-5">
                      {{ $t("views.perfil_marca.text7") }}:
                    </h2>
                    <ul v-if="item.contacts.length > 0">
                      <li v-for="(contact, key) in item.contacts" :key="key" class="mt-2">
                        <div class="w-2 h-1 rounded-full bg-gray-400 inline-block mr-2"></div>
                        {{ contact.nameCont }} - {{ contact.position }} - {{ contact.email }} - {{ contact.phone }}
                      </li>
                    </ul>
                    <!-- Certifications -->
                    <h2 v-if="item.certification && item.certification.length" class="dark:text-white font-medium mt-3">
                      {{ $t("views.perfil_marca.text15") }}:
                    </h2>
                    <div v-if="item.certification && item.certification.length" class="flex space-x-2 mt-3">
                      <span
                        v-for="(cert, index) in item.certification"
                        :key="index"
                        class="py-1 px-2 rounded-md text-xs bg-theme-9 text-white cursor-pointer font-medium mr-3 my-1 bg-color-1"
                      >
                        {{ getNameCertification(cert) }}
                      </span>
                    </div>
                  </div>
                </td>
                <td class="table-report__action w-56 relative p-5" style="width: 25px">
                  <div
                    class="alert show py-1 px-4 w-max h-max-content text-white"
                    :class="{ 'green-ok': item.status == 2, 'red-danger': item.status == 1 }"
                  >
                    {{ $t(`views.perfil_marca.${getNameStatus(item.status)}`) }}
                  </div>
                </td>
                <td class="table-report__action w-56 relative p-5" style="width: 25px">
                  <div class="flex justify-center items-center">
                    <a class="flex items-center mr-3" href="javascript:;" @click="editMarcaSupplementItem(item)">
                      <CheckSquareIcon class="w-4 h-4 mr-1" />
                      {{ $t("views.edit") }}
                    </a>
                  </div>
                </td>
              </tr>
            </template>
            <tr v-if="loading">
              <td colspan="4" class="p-4">
                {{ $t("views.loading") }}
                <LoadingIcon icon="three-dots" color="currentColor" class="ml-4 inline-block" />
              </td>
            </tr>
            <tr>
              <td colspan="4" class="p-4">
                {{ $t("views.no_data") }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END: Data List -->
      <!-- BEGIN: Pagination -->
      <div class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-nowrap items-center" v-if="brands.length > 0">
        <ul class="pagination">
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage(1)">
              <ChevronsLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage('prev')">
              <ChevronLeftIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a
              class="pagination__link"
              v-if="pagination.total_pages >= getNumberPgae('first')"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('first') }"
              href="javascript:;"
              @click="goPage(getNumberPgae('first'))"
              >{{ getNumberPgae("first") }}</a
            >
          </li>
          <li>
            <a
              class="pagination__link"
              v-if="pagination.total_pages >= getNumberPgae('second')"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('second') }"
              href="javascript:;"
              @click="goPage(getNumberPgae('second'))"
              >{{ getNumberPgae("second") }}</a
            >
          </li>
          <li v-if="getNumberPgae('second') != getNumberPgae('') && pagination.total_pages >= getNumberPgae('')">
            <a
              class="pagination__link"
              v-bind:class="{ 'pagination__link--active': pagination.page == getNumberPgae('') }"
              href="javascript:;"
              @click="goPage(getNumberPgae(''))"
              >{{ getNumberPgae("") }}</a
            >
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage('next')">
              <ChevronRightIcon class="w-4 h-4" />
            </a>
          </li>
          <li>
            <a class="pagination__link" href="javascript:;" @click="goPage(pagination.total_pages)">
              <ChevronsRightIcon class="w-4 h-4" />
            </a>
          </li>
        </ul>
        <div class="ml-auto mr-5 text-gray-600">
          {{ $t("views.pagination.items", { total: brands.length }) }}
        </div>
        <select
          class="w-20 form-select box mt-3 sm:mt-0"
          v-model="pagination.per_page"
          @change="
            () => {
              changePerPage();
            }
          "
        >
          <option>10</option>
          <option>25</option>
          <option>35</option>
          <option>50</option>
        </select>
      </div>
      <!-- END: Pagination -->
    </div>
  </div>
</template>
<style scoped>
.cursor {
  cursor: pointer !important;
}

.table td.p-0 {
  padding: 0px !important;
}

.bg-color-1 {
  background-color: #828181;
}

.btn-primary {
  background: #6c869a !important;
  border-color: #6c869a !important;
}
</style>
<style>
.tom-select .ts-dropdown .option.active {
  background: #6c869a !important;
}

.top-bar .breadcrumb > a:not(.breadcrumb--active) {
  color: #6c869a !important;
}

.detail-food {
  display: grid;
  grid-auto-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 2em;
  grid-row-gap: initial;
  -ms-grid-columns: 1fr 1fr 1fr 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

.pagination li,
.pagination a,
.pagination a:focus,
.pagination a:active {
  outline: none !important;
}

.supplements-grid {
  grid-template-columns: 150px 200px 150px 150px 150px;
  align-items: center;
  width: 100%;
}

.certifications-container {
  display: flex;
  gap: 10px;
}

@media screen and (min-width: 1450px) {
  .supplements-grid {
    grid-template-columns: 12vw auto 15vw 12vw 12vw;
  }
}
</style>

<script>
import BrandsService from "@/services/brands.service";
import _ from "lodash";

export default {
  setup() {},
  data() {
    return {
      brands: [],
      searchInput: "",
      pagination: {
        page: 1,
        total_pages: 3,
        per_page: 50,
        total: 0,
      },
      certificationsBrand: [],
      certification: 0,
      bg: 1,
      loading: true,
      statusFilter: "",
      status: this.$global.getAspect(),
    };
  },
  watch: {
    searchInput: _.debounce(function (newSearch, oldSearch) {
      this.pagination.page = 1;
      this.getAll();
    }, 500),
    certification: function () {
      this.pagination.page = 1;
      this.getAll();
    },
    statusFilter: function () {
      this.pagination.page = 1;
      this.getAll();
    },
  },
  created() {
    window.vue = this;
    this.getAll();
    this.getCertificationsBrand();
  },
  methods: {
    getNameStatus(codeStatus) {
      switch (Number(codeStatus)) {
        case 1:
          return "UNREVIEWED";
        default:
          return "REVIEWED";
      }
    },
    getAllBrand() {
      const brands = localStorage.getItem("brands");
      if (brands) {
        try {
          return JSON.parse(brands);
        } catch {
          return [];
        }
      } else {
        return [];
      }
    },
    getAll() {
      var params = {
        pagination: this.pagination,
      };
      if (this.searchInput != "") {
        params.search = this.searchInput.replaceAll(" ", "_");
      }
      if (this.statusFilter !== "") {
        params.status = this.statusFilter;
      }
      if (this.certification > 0) {
        params.certification = this.certification;
      }

      this.loading = true;
      try {
        let brands = this.getAllBrand();

        if (params.search) {
          brands = brands.filter((s) => s.name.toLowerCase().includes(params.search.toLowerCase()));
        }

        if (params.certification) {
          brands = brands.filter((s) => s.certificationId == params.certification);
        }

        // Paginación simulada
        const start = (this.pagination.page - 1) * this.pagination.per_page;
        const end = start + this.pagination.per_page;
        const paginatedBrands = brands.slice(start, end);

        this.brands = paginatedBrands.map((s) => {
          s.show = false;
          if (!s.contact) {
            s.contact = {
              name: null,
              position: null,
              email: null,
              phone: null,
            };
          }
          return s;
        });
        this.pagination.total_pages = Math.ceil(brands.length / this.pagination.per_page);
        this.pagination.total = brands.length;

        this.loading = false;
      } catch (error) {
        console.error("Error las marcas:", error);
        this.loading = false;
      }
    },
    getCertificationsBrand() {
      var _this = this;
      BrandsService.getCertificationsBrands()
        .then((response) => {
          _this.certificationsBrand = response.data ? response.data : response;
          var sB = _this.certificationsBrand.filter((b) => {
            return _this.brands.certificationsBrand.includes(b.name);
          });
          _this.brands.certificationsBrand = sB.map((b) => {
            return b.certification.toString();
          });
        })
        .catch(function (e) {
          _this.loading = false;
        });
    },
    editMarcaSupplementItem(brandItem) {
      console.log("Guardando marca en localStorage:", brandItem);
      localStorage.setItem("brandItem", JSON.stringify(brandItem));
      this.$router.push({ path: "/supplement-marcas-edit" });
    },
    newMarcaSupplementItem(brandItem) {
      localStorage.removeItem("brandItem");
      this.$router.push({ path: "/supplement-marcas-new" });
    },
    goPage: function (param) {
      if (param == "prev") {
        this.pagination.page = this.pagination.page > 1 ? this.pagination.page - 1 : 1;
      } else if (param == "next") {
        this.pagination.page =
          this.pagination.page < this.pagination.total_pages ? this.pagination.page + 1 : this.pagination.total_pages;
      } else {
        this.pagination.page = param;
      }
      this.getAll();
    },
    getNumberPgae(type) {
      if (type == "first") {
        return this.pagination.page < 3 ? 1 : this.pagination.page - 1;
      } else if (type == "second") {
        return this.pagination.page > 2 ? this.pagination.page : 2;
      } else {
        return this.pagination.page > 2
          ? this.pagination.page + 1 > this.pagination.total_pages
            ? this.pagination.total_pages
            : this.pagination.page + 1
          : 3;
      }
    },
    changePerPage() {
      this.pagination.page = 1;
      this.pagination.per_page = Number(this.pagination.per_page);
      this.getAllBrand();
    },
    getNameCertification(id) {
      const cb = this.certificationsBrand.find((cb) => cb.id == id);
      if (cb) {
        return cb.name;
      }
      return "";
    },
  },
};
</script>
